<template>
  <pt-obs-department-question class="pt-obs-department-question__page"></pt-obs-department-question>
</template>

<script>
import PtObsDepartmentQuestion from 'cps/obs-department/pt-obs-department-question/withData'
export default {
  name: 'pt-obs-department-question__view',
  components: {
    'pt-obs-department-question': PtObsDepartmentQuestion
  }
}
</script>
